import React, { Component } from "react";
import moment from 'moment';
import Search from '../../components/Search/Search'

export default class ConferenceContent extends Component {

    constructor(props) {
        super(props)

        this.state = {
            active: 0,
            page: 0
        }


    }

    setPage = (page) => {
        this.setState({ page })
    }

    render() {
        const { data, setResult } = this.props
        const { active } = this.state
        return (
            <div className="container">
                <div className="content">
                    {/* Search */}
                    <div className="search-level">
                        <div className='search-level-left' >
                            <p id='title'>{'การประชุม'}  </p>
                        </div>
                        <div className='search-level-right' >
                            <Search setResult={setResult} />
                        </div>
                    </div>
                    <div>
                        <div className="content-box">
                            <nav className="breadcrumber-content">
                                <ul>
                                    <li />
                                    <li>
                                        <a
                                            className={active === 0 ? "active" : "not-active"}
                                            onClick={this.handleAll}
                                        >
                                            ทั้งหมด</a>
                                    </li>
                                    <li>
                                        <a
                                            className={active === 1 ? "active" : "not-active"}
                                            onClick={this.handleNotRead}
                                        >
                                            ยังไม่อ่าน</a>
                                    </li>
                                    <li>
                                        <a
                                            className={active === 2 ? "active" : "not-active"}
                                            onClick={this.handleRead}
                                        >
                                            อ่านแล้ว</a>
                                    </li>
                                </ul>
                            </nav>

                            {active === 0 && data
                                ? this.renderAll(data)
                                : active === 1 && data
                                    ? this.renderNotRead(data)
                                    : active === 2 && data ? this.renderReaded(data) : null}

                            {this.renderPagination(active)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleAll = () => {
        this.setState({ active: 0 })
        this.setPage(0)

    }

    handleNotRead = () => {
        this.setState({ active: 1 })
        this.setPage(0)
    }

    handleRead = () => {
        this.setState({ active: 2 })
        this.setPage(0)
    }

    renderAll = data => {
        const { page } = this.state
        const { onClick } = this.props
        return (
            <div className="conference-content">
                {data.map((el, i) => {
                    const date = moment(el.meeting_time).format("DD/MM/YYYY");
                    return i >= page * 3 && i < (page + 1) * 3 ?
                        <ConferenceBox
                            key={el.conference_id}
                            title={el.title}
                            content={el.detail}
                            readStatus={el.read}
                            date={date}
                            conferenceId={el.conference_id}
                            onClick={onClick}
                        /> : null
                })}

            </div>
        );
    };

    renderNotRead = (data) => {
        const { page } = this.state
        const { onClick } = this.props
        const newData = data.filter(el => !el.read)
        return (
            <div className="conference-content">
                {newData.map((el, i) => {
                    const date = moment(el.meeting_time).format("DD/MM/YYYY");
                    return i >= page * 3 && i < (page + 1) * 3 ? (
                        <ConferenceBox
                            key={el.conference_id}
                            title={el.title}
                            content={el.detail}
                            readStatus={el.read}
                            date={date}
                            conferenceId={el.conference_id}
                            onClick={onClick}
                        />
                    ) : null
                })}
            </div>
        );
    };

    renderReaded = (data) => {
        const { page } = this.state
        const { onClick } = this.props
        const newData = data.filter(el => el.read)

        return (
            <div className="conference-content">
                {newData.map((el, i) => {
                    // console.log(el.read)
                    const date = moment(el.meeting_time).format("DD/MM/YYYY");
                    return i < (page + 1) * 3 && i >= page * 3 ? (
                        <ConferenceBox
                            key={el.conference_id}
                            title={el.title}
                            content={el.detail}
                            readStatus={el.read}
                            date={date}
                            conferenceId={el.conference_id}
                            onClick={onClick}
                        />
                    ) : null
                })}
            </div>
        );
    };

    renderPagination = (active) => {
        const { data } = this.props;
        const { page } = this.state
        let paginationItem = 0
        var statePagination = true;
        switch (active) {
            case 0:
                paginationItem = data ? Math.ceil(data.length / 3) : 0;
                break;
            case 1:
                paginationItem = data ? Math.ceil(data.reduce((accum, cv, ci) => !cv.read ? ++accum : accum, 0) / 3) : 0;
                break;
            case 2:
                paginationItem = data ? Math.ceil(data.reduce((accum, cv, ci) => cv.read ? ++accum : accum, 0) / 3) : 0;
                break;
            default:
                break;
        }

        // console.log(paginationItem);
        paginationItem > 0 ? statePagination = true : statePagination = false;

        return (
            statePagination ?
                <nav className="pagination-content" aria-label="pagination">
                    <ul className="pagination-list">
                        <li />
                        <li>
                            <a className="pagination-link" onClick={() => page > 0 ? this.setPage(page - 1) : false}>
                                <img
                                    id="first-arrow"
                                    src={require("../../assets/icon/arrow.png")}
                                    alt="arrow"
                                />
                            </a>
                        </li>

                        {page > 0 ? (
                            <li>
                                <span className="pagination-ellipsis">&hellip;</span>
                            </li>
                        ) : null}

                        {data
                            ? Array.from(new Array(3), (el, i) => (
                                <li key={i}>
                                    <a
                                        className={
                                            i === 0 && paginationItem !== 0
                                                ? "pagination-link is-current"
                                                : "pagination-link"
                                        }
                                        aria-label={page}
                                        onClick={() =>
                                            page + i < paginationItem ? this.setPage(page + i) : false
                                        }
                                        disabled={page + i > paginationItem - 1 ? true : false}
                                    >
                                        {page + i + 1}
                                    </a>

                                </li>
                            ))
                            : null}

                        {paginationItem > 2 ? (
                            <li>
                                <span className="pagination-ellipsis">&hellip;</span>
                            </li>
                        ) : null}

                        <li>
                            <a className="pagination-link" onClick={() => page < paginationItem - 1 ? this.setPage(page + 1) : false} >
                                <img
                                    id="last-arrow"
                                    src={require("../../assets/icon/arrow.png")}
                                    alt="arrow"
                                />{" "}
                            </a>
                        </li>
                    </ul>
                </nav> : <p className="text-none"> ไม่มีการประชุม </p>
        );
    };
}

class ConferenceBox extends Component {
    render() {
        let { title, content, date, readStatus, conferenceId, onClick } = this.props;
        return (
            <div className="conference-box">
                <div className="conference-box-left">
                    <span className="conference-title" onClick={onClick(conferenceId)}>
                        {title ? title : "หัวข้อ"}</span>
                    <div className="text ellipsis">
                        <p className="conference-content">{content ? content : "เนื้อหา"}</p>
                    </div>
                    <span className="conference-date">
                        {" "}
                        {date ? date : "01/01/2018"}{" "}
                        <button
                            className={
                                readStatus ? "conference-status-read" : "conference-status"
                            }
                            disabled
                        >
                            {" "}
                            {readStatus ? "อ่านแล้ว" : "ยังไม่อ่าน"}
                        </button>
                    </span>
                </div>
                <div className="conference-box-right">
                    <button
                        className="conference-detail-btn"
                        onClick={onClick(conferenceId)
                        }
                    >
                        รายละเอียด
            </button>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/pages/Main/ConferenceContent.js